/* eslint-disable no-nested-ternary */
import React, { useContext, useState } from "react";
import styled, { ThemeContext } from "styled-components";
import circArrowDown from "../../assets/images/vctr-contract.svg";
import circArrowUp from "../../assets/images/vctr-expand.svg";
import smallArrowDown from "../../assets/images/vctr-small-down-arrow.svg";
import smallArrowUp from "../../assets/images/vctr-small-up-arrow.svg";
import { Box } from "../Box";
import { Flex } from "../Flex";
import { Image } from "../Image";
import { Link } from "../Link";
import { Text } from "../Text";

interface Props {
  title: string;
  url?: string;
  subMenu?: boolean;
  color?: string;
  arrow?: boolean;
  myProfile?: boolean;
}

export const StyledBox = styled(Box)`
  display: inline-block;
  text-align: end;
  height: 45px;
  width: 20%;
`;

export const NavAccordion: React.FC<Props> = ({ title, url, subMenu, arrow, children, color, myProfile }) => {
  const [show, setShow] = useState<boolean>(false);
  const handleClick = () => setShow(prevState => !prevState);

  const theme = useContext(ThemeContext);
  const { white } = theme.colors;

  const arrowUp = arrow ? smallArrowUp : subMenu ? circArrowUp : " ";
  const arrowDown = arrow ? smallArrowDown : subMenu ? circArrowDown : " ";

  return (
    <Flex flexDirection="column">
      <Flex bg={color} justifyContent="space-between">
        <Box width="80%">
          <Link data-testid="NavAccordionLink" href={url || " "}>
            <Text
              color={white}
              p={
                !myProfile ? (color !== "primary" ? (color !== "accent" ? "16px 20px 16px 40px" : "16px 20px 16px 30px") : "13px") : "20px"
              }
              m={0}
              ml={myProfile ? "20px" : "0"}
              fontWeight="400"
            >
              {title}
            </Text>
          </Link>
        </Box>
        {myProfile ? null : (
          <StyledBox onClick={handleClick}>
            {subMenu ? (
              <Image mt={arrow ? "20px" : "10px"} mr={arrow ? "10px" : "5px"} src={show ? arrowUp : arrowDown} alt="arrows" />
            ) : null}
          </StyledBox>
        )}
      </Flex>
      {show || myProfile ? (
        <Box data-testid="ExpandedNavAccordion" ml={myProfile ? "10px" : "0"}>
          {children}
        </Box>
      ) : null}
    </Flex>
  );
};
